import { render, staticRenderFns } from "./welfare-item.vue?vue&type=template&id=3b6318d0&scoped=true"
import script from "./welfare-item.vue?vue&type=script&lang=js"
export * from "./welfare-item.vue?vue&type=script&lang=js"
import style0 from "./welfare-item.vue?vue&type=style&index=0&id=3b6318d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6318d0",
  null
  
)

export default component.exports